// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ib-0";
export var optionCard = "_ib-1";